import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Flag05 = function Flag05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.1111 6.7222h6.0293c.4473 0 .671 0 .8018.094a.5.5 0 0 1 .2047.348c.0187.16-.0899.3555-.3071.7465l-1.4696 2.6452c-.0788.1418-.1182.2127-.1336.2878a.5.5 0 0 0 0 .2014c.0154.0751.0548.146.1336.2878l1.4696 2.6452c.2172.391.3258.5865.3071.7465a.5.5 0 0 1-.2047.348c-.1308.094-.3545.094-.8018.094h-7.5959c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437c-.109-.2139-.109-.4939-.109-1.054v-2.6222M7.25 21.5002 3.0278 4.6113m1.5834 6.3331h7.9c.56 0 .84 0 1.0539-.1089a1 1 0 0 0 .4371-.4371c.109-.2139.109-.4939.109-1.054V4.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.4371-.437c-.2139-.109-.4939-.109-1.0539-.109h-7.962c-.6984 0-1.0477 0-1.2866.1447a1 1 0 0 0-.4372.56c-.0825.2669.0022.6057.1716 1.2834z"
    })
  }));
};
export default Flag05;